import React from 'react'
import { FormattedMessage } from 'react-intl'
import { embedableYoutubeVideo } from 'helpers/youtubeVideo'

export default class IsYoutubeLink {
  constructor({ value }) {
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_youtube_link" />
  }

  validate() {
    if (!embedableYoutubeVideo(this.value)) {
      return this.errorMessage
    }

    return null
  }
}
